import React, { FC, ChangeEvent, useCallback, useEffect } from "react";
import { useValidationServerError } from "../../../hooks/useValidationServerError";
import { ServerValidationError } from "../../Dialogs/FeaturesMultiEdit/components/ServerValidationError";

import { ConditionEditorContainer, ConditionEditorInput } from "../styled";

import { FilterConditionsDevModeProps } from "../types";

export const ConditionEditor: FC<FilterConditionsDevModeProps> = ({ condition, setCondition }) => {
  const { error, setError } = useValidationServerError();

  const onChangeCondition = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => setCondition(e.target.value),
    [setCondition],
  );

  useEffect(() => {
    setError(null);
  }, []);

  return (
    <ConditionEditorContainer>
      <ConditionEditorInput
        width={"100%"}
        value={condition || ""}
        onChange={e => {
          error && setError(null);
          onChangeCondition(e);
        }}
        error={!!error}
        help={error ? <ServerValidationError error={error} /> : ""}
      />
    </ConditionEditorContainer>
  );
};
